import { legacyPlugins } from "/opt/atlassian/pipelines/agent/build/node_modules/.pnpm/@unhead+vue@3.4.2_@oxc-project+types@0.153.0_esbuild@0.28.2_lightningcss@1.33.0_oxc-par_565e1e8e95531ffc3f40c59eac245789/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}